var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentbox"},[_vm._m(0),_c('div',{staticClass:"logobox-btn"},[_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.goMiniApp}},[_vm._v("进入菠萝蜜短剧")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logobox"},[_c('img',{staticClass:"logobox-img",attrs:{"src":require("../assets/images/blmlogo.jpg")}})])
}]

export { render, staticRenderFns }